import { cn } from "./lib/cn.js";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "success" | "warning" | "danger";
  className?: string;
}

const badgeVariants = {
  default: "bg-border-muted text-fg",
  success: "bg-success-border text-success-fg",
  warning: "bg-warning-border text-warning-fg",
  danger: "bg-danger-border text-danger-fg",
} as const;

export function Badge({ children, variant = "default", className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-soft-sm px-2 py-0.5 text-xs font-medium",
        badgeVariants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
